import { AccountabilityOverview } from "@/types";
import { apiClient } from "@/lib/apiClient";
import { parseAccountabilityOverview } from "@/services/accountabilityTransforms";

/**
 * Accountability Service
 * Read-only overview: DRIs ranked by task count, and who is blocking whom.
 */
export const accountabilityService = {
  getOverview: async (): Promise<AccountabilityOverview> => {
    const raw = await apiClient.get<unknown>("/api/priorities/accountability");
    return parseAccountabilityOverview(raw);
  },
};
